<div class="section">
  <!--bg triangle-->
  @if (utilService.getWidth() > 1024) {
    <div class="bg-triangle"></div>
  }
  <!--bg triangle-->

  <!--web logo-->
  @if (utilService.getWidth() > 1024) {
    <div class="_wf-lp-logo-container">
      @if (!headerInfo.default_login_logo_needed) {
        <div class="_wf-lp-logo">
          <img class="image-35" src="/assets/images/Sample logo.png">
        </div>
      }
      @if (headerInfo.default_login_logo_needed) {
        <div class="_wf-lp-logo">
          <img class="image-35" [src]="headerInfo.login_logo">
        </div>
      }
      <!--super app-->
      <!-- <div *ngIf="superApps && superApps.length>1" id="super-app" class="dropdown header-dropdown dd-hover" data-toggle="dropdown"
      [triggered]="config.showSuperAppMenu" aria-haspopup="true" aria-expanded="false"
      (click)="config.showSuperAppMenu = !config.showSuperAppMenu;">
      <div class="super-app-icon-container">
        <i class="fa fa-th" aria-hidden="true"></i>
      </div>
      <div id="super-app-m-body" class="_menu-dropdown dropdown-menu dropdown-menu-right dropdown-menu-sm"
        style="top: 40px;display:block;"
        [hidden]="config.showSuperAppMenu == undefined || !config.showSuperAppMenu">
        <div class="dropdown-header">
          <strong>Select Application</strong>
        </div>
        <dhs-domain-platform [domainPlatformList]="appService._currentSessionData.superApps">
        </dhs-domain-platform>
      </div>
    </div> -->
  </div>
}
<!--web logo-->
<div class="_wf-lp-login-form-container">
  <!-- <div class="text-block-377 _wf-lp-textbox-formobile" *ngIf="headerInfo.default_tagline_needed"><span
[innerHtml]="headerInfo.login_tag"></span></div> -->
<div class="_wf-lp-blockll-for-shadow"></div>
<img [src]="headerInfo.banner" alt="" class="image-36"
  onerror="this.onerror=null;this.src='/assets/images/login-BG.png';">
  <!-- <div class="display_msg">{{headerInfo.name}} Healthcloud</div> -->
  <div class="_wf-lp-image-container">
    <!-- <div class="text-block-377" *ngIf="headerInfo.default_tagline_needed"><span
    [innerHtml]="headerInfo.login_tag">
</span>
</div> -->
<img [src]="headerInfo.banner" loading="lazy"
  sizes="(max-width: 479px) 100vw, (max-width: 1919px) 57vw, 61vw" alt="" class="image-37"
  onerror="this.onerror=null;this.src='/assets/images/login-BG.png';">
</div>
<div class="_wf-lp-whitebg">
  <div class="_wf-lp-login-form" style="display: block;">
    <div class="login-overlay hide-after-1024px">
    </div>

    <div class="_wf-lp-form-block">
      @if (utilService.isMobile()) {
        <div class="close-btn-form" (click)="navigateToLogin()">
          <i class="fa fa-times-circle"></i>
        </div>
      }
      @if (!registerUser) {
        <div class="mb-4">
          <!-- <div class="forgot-password-top-section">
          <a class="d-inline-flex" href="javascript:void(0)" (click)="backToReset()" *ngIf="show">
            <img src="assets/images/grid-back.png" />
          </a>
        </div> -->
        <div class="pass-screen form-top-section">
          <!--for navigate back to login screen-->
          @if (!show && !showOtpComponent) {
            <div class="landing-form-back-button-container">
              <a class="" href="javascript:void(0)" (click)="navigateToLogin()">
                <img src="assets/images/grid-back.png">
              </a>
            </div>
          }
          <!--for navigate back to forgot password screen-->
          <div class="landing-form-back-button-container">
            @if (showOtpComponent && showTimer) {
              <a class="back-not-allowed" href="javascript:void(0)"
                >
              <img src="assets/images/grid-back.png" />
            </a>
          }
          @if (showOtpComponent && !showTimer) {
            <a class="" href="javascript:void(0)" (click)="backToForgotPass()"
              >
              <img src="assets/images/grid-back.png" />
            </a>
          }
        </div>
        <!--for navigate back to otp screen-->
        <div class="landing-form-back-button-container">
          @if (show) {
            <a class="" href="javascript:void(0)" (click)="backToReset()">
              <img src="assets/images/grid-back.png" />
            </a>
          }
        </div>
        <div class="landing-form-heading">
          {{'field.label.reset_password' | translate | async }}
        </div>
        <div class="language-sel">
          <dhs-langugage-selection [languageList]="appService._currentSessionData.languageList"
            (languageVal)="languageChange($event)">
          </dhs-langugage-selection>
        </div>
      </div>
      <form class="mt-4 forgotPasswordForm" [formGroup]="forgotPasswordForm">
        <!-- <div class="row"> -->
        @if (!show && !showOtpComponent) {
          <div>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0">
              <div class="floating-input-group c-mb-3">
                <ng-template #errorTemplate>
                  <div>
                    @if (f.login_id.errors.required) {
                      <div>
                      {{'required.login_id' | translate | async }}</div>
                    }
                    @if (f.login_id.errors.minlength) {
                      <div>
                        {{'field.label.ogin_cannot_be_2' | translate | async }}
                      </div>
                    }
                    @if (f.login_id.errors.maxlength) {
                      <div>
                      {{'validation.maxlength.login_id' | translate | async }}</div>
                    }
                    @if (f.login_id.errors.pattern) {
                      <div>
                      {{'validation.pattern.login_id' | translate | async }}</div>
                    }
                  </div>
                </ng-template>
                <input type="text" class="form-control floating-input" (input)="onLoginid()"
                  formControlName="login_id"
                  [ngClass]="{ 'is-invalid': submitted && f.login_id.errors }" minlength="2"
                  maxlength="50" [pattern]="checkPattern" autofocus required>
                <label class="floating-placeholder" for="Login ID">{{'field.label.login_id' |
                translate | async }}</label>
                <!-- <div class="kx-error-msg" *ngIf="forgotPasswordForm.controls.login_id.invalid && forgotPasswordForm.controls.login_id.touched">
                <div *ngIf="forgotPasswordForm.controls.login_id.errors.required">Login Id is Required</div>
              </div> -->
              @if (submitted && f.login_id.errors) {
                <div class="input-detail-error form-v2"
                  [popover]="errorTemplate" triggers="mouseenter:mouseleave">
                  <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                </div>
              }
              <!-- <div>
              <div *ngIf="f.login_id.errors.required">
              {{'required.login_id' | translate | async }}</div>
              <div *ngIf="f.login_id.errors.minlength">
              {{'validation.minlength.login_id' | translate | async }}</div>
              <div *ngIf="f.login_id.errors.maxlength">
              {{'validation.maxlength.login_id' | translate | async }}</div>
              <div *ngIf="f.login_id.errors.pattern">
              {{'validation.pattern.login_id' | translate | async }}</div>
            </div> -->
          </div>
        </div>
        @if (isKarexpert=='karexpert') {
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0"
            >
            <div class="floating-input-group c-mb-3">
              <ng-template #errorTemplate2>
                <div>
                  @if (f.account_url.errors.required) {
                    <div>{{'required.account_id' |
                    translate | async }}</div>
                  }
                  @if (f.account_url.errors.minlength) {
                    <div>
                      {{'field.label.account_Url_required' | translate | async }}
                    </div>
                  }
                  @if (f.account_url.errors.maxlength) {
                    <div>
                      {{'field.label.account_Url_not_exceed' | translate | async }}
                    </div>
                  }
                  @if (f.account_url.errors.pattern) {
                    <div>
                      {{'field.label.only_alphabet_hyphen_dot_numbers' | translate | async
                    }}</div>
                  }
                </div>
              </ng-template>
              <!-- <label class="control-label" for=""><strong>Account Url</strong><sup
            class="req">*</sup></label> -->
            <input type="text" formControlName="account_url"
              class="form-control floating-input"
              [ngClass]="{ 'is-invalid': submitted && f.account_url.errors }"
              minlength="2" maxlength="255" pattern="^[a-zA-Z0-9&._@]+" required />
            <label class="floating-placeholder" for="">{{'field.label.account_url' |
            translate | async }}</label>
            @if (submitted && f.account_url.errors) {
              <div
                class="input-detail-error form-v2" [popover]="errorTemplate2"
                triggers="mouseenter:mouseleave">
                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
              </div>
            }
            <!-- <div>
            <div *ngIf="f.account_url.errors.required">Account Url is required</div>
            <div *ngIf="f.account_url.errors.minlength">Account Url requied atleast 2
              characters.
            </div>
            <div *ngIf="f.account_url.errors.maxlength">Account Url can not exceed 255
              characters.
            </div>
            <div *ngIf="f.account_url.errors.pattern">Only Alphabet, hyphen, dot and
            numbers are allowed.</div>
          </div> -->
        </div>
      </div>
    }
    <div class="col-12 p-0 mt-42">
      <button class="login-button btn-gradient button-hover text-white"
        (click)="generateOTP()">{{'button.generate_otp' | translate | async }}
        <i class="fa fa-angle-right lg-btn-icon" aria-hidden="true"></i>
      </button>
    </div>
  </div>
}
</form>
@if (showOtpComponent) {
  <div class="mt-2">
    <!-- <p>We have sent you 6 digit verification code on your mobile to verify contact details.</p> -->
    <p>{{'field.label.Enter_OTP' | translate | async }}</p>
  </div>
}
@if (showOtpComponent) {
  <app-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)"
    [config]="config" [resetOTP]="ResetsetOpt">
  </app-otp-input>
}
@if (showOtpComponent) {
  <div class="col-12 p-0 mt-4">
    <button class="login-button btn-gradient button-hover text-white" (click)="verifyOtp()"
      #changeOtpBtn disabled>
      {{'button.label.next' | translate | async}} <i class="fa fa-angle-right lg-btn-icon"
    aria-hidden="true"></i>
  </button>
</div>
}
<!-- <div class="col-12 p-0 mt-4">
<span *ngIf="!showTimer" [ngClass] style="cursor: pointer;color: #20a8d8;"
(click)="generateOTP()">Resend Code</span>
<span *ngIf="showTimer" style="cursor: not-allowed; color: gray;">Resend Code</span>
<span class="timer" *ngIf="showTimer">
  {{timer}} sec
</span>
</div> -->
@if (showOtpComponent) {
  <div class="col-12 mt-1 p-0">
    @if (!showTimer) {
      <span class="cLink" (click)="generateOTP()" (click)="clear()">
      {{'field.label.resend_OTP' | translate | async }}</span>
    }
    @if (showTimer) {
      <span class="timer" style="cursor: not-allowed; color: gray;">
        {{'field.label.resend_OTP_in_timer_sec' | translate | async }} {{timer}}
        {{'field.label.seconds' | translate | async}}
      </span>
    }
  </div>
}
<form [formGroup]="forgotPasswordFormOTP" (ngSubmit)="forgotPassword()">
<!-- </div>
<div class="row" *ngIf="show"> -->
  @if (show && !showOtpComponent) {
    <div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0">
        <div class="floating-input-group c-mb-3 has-icon">
          <!-- <label class="control-label" for=""><strong>New Password</strong><sup
        class="req">*</sup></label> -->
        <input (input)="passwordValidator()" class="form-control floating-input"
          formControlName="password" type="{{eye != 'fa-eye'?'text':'password'}}"
          [ngClass]="{ 'is-invalid': submitted_forgot && fp.password.errors }"
          minlength="6" maxlength="20" class="form-control floating-input" required>
        <label class="floating-placeholder" for="">{{'field.label.new_password' |
        translate | async }}</label>
        @if (submitted_forgot && fp.password.errors) {
          <div
            class="input-detail-error form-v2" [popover]="errorTemplate3"
            triggers="mouseenter:mouseleave">
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          </div>
        }
        <div class="input-group-append pass-eye-btn">
          <div class="input-group-text pass-eye">
            <span (click)="eye=(eye == 'fa-eye' ? 'fa-eye-slash':'fa-eye')">
              <i class="fa {{eye}}"></i>
            </span>
          </div>
        </div>
        <ng-template #errorTemplate3>
          @if (fp.password.errors.required) {
            <div>{{'field.label.required.password' |
            translate | async }}</div>
          }
          @if (fp.password.errors.pattern) {
            <div>
              {{'field.label.only_alphabet_hyphen_dot_numbers' | translate | async }}
            </div>
          }
          @if (fp.password.errors.minlength) {
            <div>
              {{'field.label.password_cannot_be_6' | translate | async }}
            </div>
          }
        </ng-template>
      </div>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0">
      <div class="floating-input-group c-mb-3 has-icon">
        <!-- <label class="control-label" for=""><strong>Confirm Password</strong><sup
      class="req">*</sup></label> -->
      <input (input)="passwordValidator()" formControlName="confirm_password"
        type="{{eye1 != 'fa-eye'?'text':'password'}}"
        [ngClass]="{ 'is-invalid': submitted_forgot && fp.confirm_password.errors }"
        minlength="6" maxlength="20" class="form-control floating-input" required>
      <label class="floating-placeholder" for=""> {{'field.label.confirm_password' |
      translate | async }}</label>
      @if ((forgotPasswordFormOTP.controls.confirm_password.invalid && forgotPasswordFormOTP.controls.confirm_password.touched) || (submitted_forgot && fp.confirm_password.errors)) {
        <div
          class="input-detail-error form-v2" [popover]="errorTemplate4"
          triggers="mouseenter:mouseleave">
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
        </div>
      }
      <div class="input-group-append pass-eye-btn">
        <div class="input-group-text pass-eye">
          <span (click)="eye1=(eye1 == 'fa-eye' ? 'fa-eye-slash':'fa-eye')">
            <i class="fa {{eye1}}"></i>
          </span>
        </div>
      </div>
      <ng-template #errorTemplate4>
        @if (fp.confirm_password.errors.required) {
          <div>
          {{'field.label.confirm_password_required' | translate | async }}</div>
        }
        @if (fp.confirm_password.errors.pattern) {
          <div>
            {{'field.label.only_alphabet_hyphen_dot_numbers' | translate | async }}
          </div>
        }
        @if (fp.confirm_password.errors.minlength) {
          <div>
            {{'field.label.password_cannot_be_6' | translate | async }}
          </div>
        }
        @if (forgotPasswordFormOTP.controls.confirm_password.errors.incorrect) {
          <div
            >
          {{'field.label.passwords_match' | translate | async }}</div>
        }
      </ng-template>
    </div>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0">
    <div class="mb-3">
      @if (image_captcha) {
        <img class="mr-4 imageHeight"
          [src]="image_captcha | safeHtml" />
      }
      <i class="fa fa-refresh cursor-pointer" aria-hidden="true"
      (click)="generateCaptcha(true)"></i>
    </div>
    <div class="floating-input-group c-mb-3">
      <!-- <label class="control-label" for=""><strong>OTP</strong><sup
    class="req">*</sup></label> -->
    <input type="text" class="form-control floating-input" formControlName="captcha"
      [ngClass]="{ 'is-invalid': submitted_forgot && fp.captcha.errors }"
      required>
    <label class="floating-placeholder"
    for="OTP">{{'field.label.type_the_characters' | translate | async }}</label>
    @if (submitted_forgot && fp.captcha.errors) {
      <div class="invalid-feedback">
        @if (fp.captcha.errors.required) {
          <div> {{'field.label.captcha_is_required'
          | translate | async }}</div>
        }
      </div>
    }
  </div>
</div>
<!-- <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0">
<span *ngIf="!showTimer" class="cLink" (click)="generateOTP()">Resend OTP</span>
<span class="timer" *ngIf="showTimer">
  Resend OTP in {{timer}} sec
</span>
</div> -->
<div class="col-12 p-0 mt-4">
  <button class="login-button btn-gradient button-hover text-white" type="submit">
  {{'button.change_password' | translate | async }}</button>
</div>
<!-- <div class="kx-control col-md-12 col-12 col-lg-12 col-xl-12 btn-center">
<button class="primary-btn" type="submit"
  [disabled]="forgotPasswordForm.invalid">Change
Password</button>
</div> -->
</div>
}
<!-- </div> -->
</form>
<!-- <div class="col-12 p-0 mt-2">
<span class="cLink" (click)="navigateToLogin()">or Log In</span>
</div> -->
@if (headerInfo.self_registration_needed) {
  <div class="col-12 p-0 mt-2">
    <!-- <span class="cLink" (click)="selfRegistration()">New Patient Registration -->
    <!-- <span class="border-bottom border-dark">Register here </span> -->
  <!-- </span> -->
</div>
}
@if (eulaList) {
  <div class="col-12 p-0 mt-3">
    <!-- <label class="kx-check-wrapper m-0">I agree to the
    <input type="checkbox" class="checkbox" checked>
    <span class="kx-check"></span>
  </label> -->
  <!-- <span (click)="showTnc()" class="border-bottom border-dark"
style="cursor: pointer; font-size: 0.9em;">Terms of Service</span> -->
</div>
}
</div>
}
@if (registerUser) {
  <div class="mb-4">
    <app-patient-registration (emitBackEvent)="backToLogin($event)"></app-patient-registration>
  </div>
}
<div class="_wf-lp-signup-container">
  <!-- <div class="d-flex w-100 align-items-center justify-content-between">
  <div class="text-block-369">{{'field.label.new_to_the_platform' | translate | async }}</div>
  <div class="_wf-lp-signup-btn" (click)="selfRegistration()">
    <div class="text-block-370">{{'field.label.sign_up' | translate | async }}</div>
  </div>
</div> -->
<!--reg mobile-->
<!-- <div class="registration-button-container" (click)="selfRegistration()" *ngIf="!utilService.isMobile() && !registerUser">
{{'field.label.sign_up' | translate | async }}
</div> -->
<!--branding mobile-->
<div class="_wf-lp-logo-footer-main _wf-lp-mobile-footer">
  <div class="_wf-lp-img-block">
    <div class="_wf-lp-footer-logo"><img src="assets/images/logo-powered-white.svg"
    loading="lazy" alt=""></div>
  </div>
</div>
<!-- <div class="terms-and-condition-container">
<div class="" *ngIf="eulaList">
  <span (click)="showTnc()" style="cursor: pointer; font-size: 0.9em;">{{'field.label.terms_of_service' | translate | async }}</span>
</div>
</div> -->
</div>
</div>
</div>
<div class="_wf-lp-logo-footer-main">
  <div class="_wf-lp-footer-logo"><img src="assets/images/logo-powered-white.svg" loading="lazy"></div>
</div>
</div>
<!-- <div class="_wf-lp-signinbtn" >
<div class="text-block-376">Sign in</div>
</div>
<div class="_wf-lp-signinbtn _wf-lp-signup">
  <div class="text-block-376">Sign up</div>
</div> -->
</div>

</div>

<div dhs-modal></div>